import { useEffect, useState } from 'react';
import styles from './index.module.css';

const CDN = 'https://d2jun3ty2bmcrf.cloudfront.net/website/img';

const COMPANIES = {
	uk: { since: 2021, name: 'INTIX Ticketing Limited', registration: ['Registered in England and Wales. Company Number 15504181.', 'Registered office: 124 City Road, London, England, EC1V 2NX'] },
	pty: { since: 2017, name: 'INTIX® Ticketing Pty Ltd' },
	llc: { since: 2021, name: 'INTIX, LLC' },
};

export function getServerSideProps(){
	return { redirect: { destination: '/discover', basePath: false, permanent: false } };
}

export default function EventRoot(){ return null; }

/**
 * Picks the INTIX company that operates the site on this hostname, matching the legal pages:
 * the UK site is INTIX Ticketing Limited, the AU, NZ and Swiss sites are INTIX Ticketing Pty Ltd,
 * and everything else (intix.com, us.intix.com) is INTIX, LLC.
 */
function companyForHost(hostname){
	if( hostname.includes('.co.uk') ){ return COMPANIES.uk; }
	if( hostname.includes('.com.au') || hostname.includes('.co.nz') || hostname.includes('.ch') ){ return COMPANIES.pty; }
	return COMPANIES.llc;
}

/**
 * Footer for the event pages. Links point to the main INTIX site, so they are plain anchors.
 * The company line depends on the hostname, so it renders after mount to avoid a hydration mismatch
 * on statically generated pages.
 */
export function Footer(){
	const [company, setCompany] = useState(null);
	const year = new Date().getFullYear();

	useEffect(() => { setCompany(companyForHost(window.location.hostname)); }, []);

	return (
		<footer className={styles.footer} role="contentinfo">
			<div className={styles.row}>
				<a className={styles.logo} href="/" aria-label="INTIX home">
					<img src={CDN + '/logo-small-console.png'} alt="INTIX" height={28} />
				</a>
				<nav className={styles.links} aria-label="Footer">
					<a href="/legal/terms">Terms of Use</a>
					<a href="/legal/privacy">Privacy Policy</a>
					<a href="https://customer.intix.com" target="_blank" rel="noopener noreferrer">Help</a>
					<a href="/about/contact">Contact Us</a>
					<a className={styles.sell} href="/sell-tickets">Sell Tickets</a>
				</nav>
				<div className={styles.badges}>
					<a href="https://apps.apple.com/au/app/intix/id1451785261" target="_blank" rel="noopener noreferrer">
						<img src={CDN + '/footer-apple-store.svg'} alt="Download on the App Store" height={40} />
					</a>
					<a href="https://play.google.com/store/apps/details?id=com.intixconsumer" target="_blank" rel="noopener noreferrer">
						<img src={CDN + '/footer-google-store.svg'} alt="Get it on Google Play" height={40} />
					</a>
				</div>
			</div>
			<div className={styles.base}>
				{ company ? (
					<>
						<span suppressHydrationWarning>© {company.since}–{year} {company.name}. All rights reserved.</span>
						{ company.registration ? (
							<span className={styles.registration}>
								{ company.registration.map((line) => <span key={line}>{line}</span>) }
							</span>
						) : null }
					</>
				) : null }
			</div>
		</footer>
	);
}
